import React, { useState, useEffect } from 'react'
import NumericKeyPad from '../../components/numeric_keypad/NumericKeyPad'
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';
import { AuthFetchAPI } from '../../api/Auth';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import QRCode from "react-qr-code";
import logo from '../../components/img/logos/logo.png'
import Socket from '../../utils/Socket.config';

import codepin from './img/icons/codigo-pin.png'


function ModalCupon({ getCouponByCode, showModalCupon, setShowModalCupon, actionCupon, randomnumberRemoteValid }) {
    //state of keypad number}
    const [showModalKeyCode, setShowModalKeyCode] = useState(false);
    const [displayNumber, setDisplayNumber] = useState('');
    const [code, setCode] = useState('0000');

    let token = localStorage.getItem('x-access-token');
    let machine = JSON.parse(localStorage.getItem('machine_vending'))
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'));
    let business = JSON.parse(localStorage.getItem('business_vending'));


    //set code's of the sesion 

    const handleSaveCode = async () => {
        setCode(displayNumber)
        getCouponByCode(displayNumber)
        setDisplayNumber('')
        setShowModalCupon(false)
        setCode('0000')
    }

    useEffect(() => {

        if (showModalCupon == true) {
            // Connection with the sockets server

            const socket = Socket({ "business_code": business.code, "branchoffice_code": branchoffice.code, "machine_code": machine.code });
            // we upate the data when the server send the signal of a new order 

            // Escuchar la validación del cupón
            socket.on('cuponValidated', (response) => {

                if (parseInt(response.validCode) === randomnumberRemoteValid) {
                    if (response.success) {
                        // Mostrar cupón válido
                        actionCupon(response)
                        setShowModalCupon(false)
                    } else {
                        // Mostrar error
                        ErrorAlert("Cupón inválido", response.message, "error");
                    }
                } else {
                    ErrorAlert("Sesion expirada", "El codigo de sesion no coinside escanea el qr nuevamente.", "warning");
                }
            });


            return () => {
                socket.disconnect();
            }
        }
    }, [showModalCupon]);




    return (
        <>

            {/*<div className='d-flex justify-content-center m-2'>
                <button className=' btn-primary-send btn-lg px-5 rounded-3 border-vending-primary' onClick={() => setShowModalCupon(true)} >
                    <i className="uil uil-shopping-cart-alt  "></i>
                    <span className='fw-bold'> Cupon </span>
                </button>
            </div>*/}

            <Modal
                show={showModalCupon}
                size='lg'
                onHide={() => setShowModalCupon(false)}
                centered>
                <Modal.Body className='m-0 p-0'>

                    <main className='vending' >
                        <span className='text-bg-dark fw-bold px-2 rounded-3' >Aplicacion de cupon</span>
                        <div className="d-flex align-items-center flex-column bd-highlight">
                            
                            <section className='bd-highlight my-lg-5 my-1 text-center mb-3'>
                                <h2 className="keyboard-title-modal">Aplica el cupo
                                    <span className='keyboard-title-modal-brand'> aqui</span>
                                </h2>
                            </section>
                            <section className='bd-highlight my-lg-5 my-1 text-center mb-3'>
                                <h2 className="keyboard-title-modal">Sesion:
                                    <span className='keyboard-title-modal-brand'> {randomnumberRemoteValid}</span>
                                </h2>
                            </section>
                            <div className="m-4  d-flex justify-content-center">

                                <QRCode
                                    value={"https://vending.smartpay.ai/applycupon/" + business.code + "/" + branchoffice.code + "/" + machine.code + "/" + randomnumberRemoteValid + "/" + token} // Asegúrate de que siempre haya texto
                                    size={300} // Tamaño del QR
                                    bgColor="#ffffff" // Color de fondo
                                    fgColor="#000000" // Color del texto
                                    level="H" // Nivel de corrección de errores
                                />
                            </div>
                            <div className='container  mt-2'>
                                <div className='vendindg-message  border-vending-primary  p-2 rounded-3'>
                                    <span className="mb-0  text-title-help text-primary">
                                        <i className="uil uil-info-circle"></i>  Escanea el código QR para ingresar el cupon.
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='bd-highlight d-block'>

                            <div className='d-flex justify-content-center mt-5'>
                                <button className='border-vending-danger  px-5 display-5 fw-bold pulse' onClick={() => (setShowModalCupon(false))} >Cerrar</button>
                            </div>
                        </div>
                    </main>

                    {/*<main className='keyboard-main-pin  d-flex align-items-center '>
                        <div className=' d-flex flex-column bd-highlight container'>
                            <div className='d-flex justify-content-center'>
                                <img className='login-kiosk-img-modal border-pin' src={codepin} alt="Logo Smart Pay" />
                            </div>

                            <section className='bd-highlight my-lg-5 my-1 text-center mb-3'>
                                <h2 className="keyboard-title-modal">Ingrese el código del
                                    <span className='keyboard-title-modal-brand'> cupon</span>
                                </h2>
                            </section>
                            <div className='d-flex justify-content-center '>
                                <section className='keyboard-steps bd-highlight w-100 row g-3 rounded-4 bg-light'>

                                    
                                    <div className={code === '0000'
                                        ? 'col-4 keyboard-step border-vending-primary rounded-4 border-3'
                                        : 'col-4 keyboard-ste'}>

                                        <h3 className={code != '0000' ? 'keyboard-steps-label text-center ' : 'keyboard-steps-label text-center '}>
                                            Codigo de cupon
                                        </h3>
                                        <p
                                            className={
                                                code != '0000'
                                                    ? 'keyboard-steps-number keyboard-steps-number-active text-center '
                                                    : 'keyboard-steps-number text-center  '}>
                                            {code}
                                        </p>
                                    </div>
                                </section>
                            </div>

                            <section className='bd-highlight w-100'>
                                <NumericKeyPad displayNumber={displayNumber} setDisplayNumber={setDisplayNumber} />
                            </section>
                            <section className='bd-highlight row'>
                               
                                <div className='col-12'>
                                    <button type="button" className="btn-vending-success w-100 rounded-4 py-lg-3 py-2 pulse fw-bold" onClick={() => (handleSaveCode())}>
                                        Consultar
                                    </button></div>
                            </section>


                        </div>

                    </main>
                    <div className='container mt-4'>
                        <button className=' btn-vending-product rounded-4' onClick={() => (setShowModalCupon(false))}>
                            <i className="uil uil-arrow-left"></i>

                        </button>
                    </div>*/}
                </Modal.Body>
                {/* <Modal.Footer className='d-flex justify-content-start m-0 p-0'>


            </Modal.Footer> */}
            </Modal>

        </>
    )
}

export default ModalCupon